'use client';

import { LayoutContainer, LoadingIndicator } from '@petsmart-ui/sparky';
import { useEffect, useRef, useState } from 'react';

import { PageSectionAnalyticsTracking } from '@libs/analytics';

import { useProduct } from '@/entities/product';
import { dataLayerPush } from '@/shared/analytics';

import { BVSubmitReviewAnalytics } from './ui';

import './ProductReviews.scss';

export function ProductReviews() {
    const { product } = useProduct();
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const reviewRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    }
                });
            },
            {
                root: null,
                rootMargin: '200px', // It is activated 200px before entering the screen
                threshold: 0.1,
            }
        );

        const currentRef = reviewRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.disconnect();
            }
        };
    }, []);

    const webStyleId = product?.webStyleId;

    return (
        <div ref={reviewRef} id="bv-reviews-section">
            {isLoading && <LoadingIndicator className="product-review__loading-indicator" />}

            {isVisible && webStyleId && (
                <LayoutContainer className="product-review__container" data-testid="product-review-layout">
                    <PageSectionAnalyticsTracking
                        sectionId="bv-reviews"
                        eventCallback={() => {
                            dataLayerPush({
                                event: 'view_page_section',
                                page_section: 'reviews',
                            });
                        }}
                        OnIntersect={() => setIsLoading(false)}
                    >
                        <div data-bv-show="reviews" data-bv-product-id={webStyleId} />
                        {!isLoading && <BVSubmitReviewAnalytics />}
                    </PageSectionAnalyticsTracking>
                    <PageSectionAnalyticsTracking
                        sectionId="bv-questions"
                        eventCallback={() => {
                            dataLayerPush({
                                event: 'view_page_section',
                                page_section: 'questions',
                            });
                        }}
                    >
                        <div data-bv-show="questions" data-bv-product-id={webStyleId} />
                    </PageSectionAnalyticsTracking>
                </LayoutContainer>
            )}
        </div>
    );
}
